import { Tree } from 'react-arborist'
import AccountPanelTreeNode from './AccountPannelTreeNode'
import { availableToColor, LIST_UP_COLOR } from 'pages/Supervision/helpers'
import { v4 as uuidv4 } from 'uuid'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import { useState, useRef, useMemo, useEffect } from 'react'

const generateData = (building, isSiteDown) => {
  if (!building) {
    return []
  }
  return {
    id: building.uuid,
    uuid: uuidv4(),
    name: building.name,
    children: building.floors.map(floor => {
      const floorAvailableLevel = isSiteDown ? 'unknown' : floor.available_level
      return {
        id: floor.uuid,
        uuid: uuidv4(),
        name: floor.name,
        data: {
          ...floor,
          buildingId: building.uuid,
          availableColor: floorAvailableLevel === 'up' ? LIST_UP_COLOR : availableToColor(floorAvailableLevel),
          available_level: floorAvailableLevel
        }
      }
    })
  }
}

const AccountPanelTree = ({ buildings, onMapClick, isSiteDown = false }) => {
  const { floorId } = useParams()
  const treeRef = useRef(null)
  const boxRef = useRef(null)
  const [selectedNode, setSelectedNode] = useState(null)

  const nodes = useMemo(() => {
    return buildings.map(sa => generateData(sa, isSiteDown))
  }, [buildings, isSiteDown])

  const handleMapClick = node => {
    onMapClick(node.data)
    setSelectedNode(node)
  }

  useEffect(() => {
    if (treeRef?.current) {
      if (treeRef.current.get(floorId) && !selectedNode) {
        treeRef.current.focus(floorId)
        setSelectedNode(treeRef.current.get(floorId))
      }
    }
  }, [treeRef, floorId, selectedNode])

  return (
    <Box 
      padding={'0 14px'}
      ref={boxRef} 
      height="100%" 
      sx={{ display: 'flex', flexDirection: 'column' }}
    >
      <Tree
        ref={treeRef}
        indent={3}
        rowHeight={32}
        paddingTop={5}
        onActivate={handleMapClick}
        data={nodes}
        renderRow={({ children, attrs, node }) => (
          <Box {...attrs} sx={{ ...(node.level === 0 ? { display: 'flex', alignItems: 'center' } : {}) }}>
            {children}
          </Box>
        )}
        width="100%"
        height={(boxRef.current?.clientHeight || 500) - 15}
      >
        {props => <AccountPanelTreeNode selectedNode={selectedNode} {...props} />}
      </Tree>
    </Box>
  )
}

export default AccountPanelTree
